import React from 'react'
import {ga} from 'shared'

export class LocationSearchButton extends React.Component {
  onClick = (event) => {
    ga('send', 'event', 'discover projects: overview', 'search by location clicked')
    this.props.showModal(event)
  }

  render() {
    return <a onClick={ this.props.showModal } className='btn btn-primary btn-large'>
             { I18n.t('discover.categories.index.search_by_location') }
           </a>
  }
}
